module.exports = __webpack_public_path__ + "media/images/front/sp/covid19/banner_header-070e78384e16f7b9aa613638e86f5e0b.png";